// 1- Mixin for pages that are embedded in an iframe in the new UI.
// 2- This mixin allows showing a confirmation popup when leaving an iframed page in the new UI.
// 3- This mixin should be deleted once all pages are implemented in the new UI without iframing.
// 4- The list of embedded pages is located in the new UI at xp-web-frontend @/utils/embedded-pages/embedded-pages.js
export default {
  data() {
    return {
      confirmedViaPostMessage: false,
      parentOrigin: '*'
    }
  },

  created() {
    if (window.self !== window.top) {
      window.addEventListener('message', this.handleIframeMessage)
    }
  },

  destroyed() {
    if (window.self !== window.top) {
      window.removeEventListener('message', this.handleIframeMessage)
    }
  },

  methods: {
    handleIframeMessage(event) {
      if (!event.data || event.data.type !== 'check_unsaved_changes') return

      if (event.origin && event.origin !== 'null') {
        this.parentOrigin = event.origin
      }

      window.parent.postMessage(
        { type: 'unsaved_changes_acknowledged' },
        this.parentOrigin
      )

      if (!this._confirmLeavePromise) {
        this._confirmLeavePromise = this.confirmLeave().finally(() => {
          this._confirmLeavePromise = null
        })
      }

      this._confirmLeavePromise
        .then(() => {
          this.confirmedViaPostMessage = true
          window.parent.postMessage(
            { type: 'unsaved_changes_confirm', confirmed: true },
            this.parentOrigin
          )
        })
        .catch(() => {
          window.parent.postMessage(
            { type: 'unsaved_changes_confirm', confirmed: false },
            this.parentOrigin
          )
        })
    },

    confirmLeave() {
      return Promise.resolve()
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/iframeLeaveConfirmationMixin.js